// @flow

import { type CheckoutReceipts, type Receipt } from './types';
import type { Country } from '@tectonics/prs/country';

export function getInstalmentsFromReceipts(receipts: CheckoutReceipts): ImmutableArray<Receipt> {
  return ((Object.values(receipts.instalments): any): ImmutableArray<Receipt>);
}

export function getInstalmentByNumber(
  receipts: CheckoutReceipts,
  instalmentNumber: number,
): ?Receipt {
  const instalmentsList = getInstalmentsFromReceipts(receipts);
  const instalmentNumberToConsider = [0, ''].includes(instalmentNumber) ? 1 : instalmentNumber;

  return instalmentsList.find(
    ({ instalments_plan }) => instalments_plan && instalments_plan.instalments === instalmentNumberToConsider
  );
}

export function getSafeInstalmentByNumber(receipts: CheckoutReceipts, instalmentNumber: number): Receipt {
  const instalment = getInstalmentByNumber(receipts, instalmentNumber);
  if (!instalment)
    throw new Error(`getSafeInstalmentByNumber: there is no instalment number: "${instalmentNumber}"`);
  return instalment;
}

export function getInstalmentByEndUser(
  receipts: CheckoutReceipts,
  paymentMethod: string,
  country: Country,
  instalmentNumber: number,
): ?Receipt {
  const paymentGroup = paymentMethod;
  const paymentType = resolvePaymentType(paymentMethod, country);

  if (
    !receipts.instalments_with_end_user_fee
    || !receipts.instalments_with_end_user_fee[paymentGroup]
    || !receipts.instalments_with_end_user_fee[paymentGroup][paymentType]
  ) {
    return undefined;
  }

  const instalmentsList = ((Object.values(receipts.instalments_with_end_user_fee[paymentGroup][paymentType]): any): ImmutableArray<Receipt>);
  const instalmentNumberToConsider = [0, ''].includes(instalmentNumber) ? 1 : instalmentNumber;

  return instalmentsList.find(
    ({ instalments_plan }) =>
      instalments_plan && instalments_plan.instalments === instalmentNumberToConsider
  );
}

function resolvePaymentType(paymentMethod: string, country: Country): string {
  if (country === 'ar' && paymentMethod === 'banktransfer') {
    return 'debin';
  }
  return paymentMethod;
}
